@if (!hasPermission) {
  <div class="flex items-center justify-center gap-2 rounded-lg border border-red-200 bg-red-50 p-6 text-sm font-semibold text-red-700">
    <mat-icon class="!text-base text-red-400">lock</mat-icon>
    Permissions Restricted
  </div>
} @else {
  <div>
    <h3 class="text-secondary mb-3 text-sm font-semibold uppercase tracking-wide">Recent Activity</h3>

    @if (loading) {
      <div class="flex justify-center py-4"><mat-spinner diameter="28" color="primary" /></div>
    }

    @if (error && !loading) {
      <div class="text-secondary flex items-center gap-2 py-3 text-sm">
        <mat-icon class="text-base text-gray-400">lock</mat-icon>
        {{ error }}
      </div>
    }

    @if (!error && !loading && activities.length === 0) {
      <div class="flex flex-col items-center gap-1.5 rounded-lg border border-dashed border-gray-200 py-8 text-center">
        <mat-icon class="!text-3xl text-gray-300">timeline</mat-icon>
        <span class="text-xs text-gray-400">No recent activity</span>
      </div>
    }

    @if (!error && !loading && activities.length > 0) {
      <div class="relative pl-4 pr-0.5">
        <!-- Vertical line -->
        <div class="absolute bottom-0 left-1.5 top-0 w-px bg-gray-100"></div>

        <div class="flex flex-col gap-2">
          @for (act of activities.slice(0, 5); track $index) {
            <div class="relative flex items-start gap-3">
              <!-- Dot -->
              <div class="absolute -left-3 mt-1 h-2 w-2 rounded-full bg-primary/70 ring-2 ring-primary/20 ring-offset-1"></div>

              <div class="min-w-0 flex-1">
                <div class="text-default text-xs leading-snug">
                  <span class="font-semibold">{{ act.causer?.first_name ? act.causer.first_name + ' ' + act.causer.last_name : (act.causer?.name ?? 'System') }}</span>
                  <span class="text-secondary ml-1" [innerHTML]="act.description ?? (act.action_type ?? act.log_name | transformTitle)"></span>
                  @if (act.subject_type) {
                    <span class="text-secondary ml-1 text-xs">({{ act.subject_type | transformTitle }})</span>
                  }
                </div>
                <div class="text-secondary/70 mt-0.5 text-[10px]">{{ formatDate(act.created_at) }}</div>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
}
